import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, isRef as _isRef, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/image/address/icon_relate.png'


const _withScopeId = n => (_pushScopeId("data-v-7d4203bb"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "content rel" }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"font-size":"14px","line-height":"32px","padding-left":"4px"} }, "&", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"font-size":"14px","line-height":"32px","padding-left":"4px"} }, "&", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"font-size":"14px","line-height":"32px","padding-top":"4px"} }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: "",
    style: {"width":"16px"}
  })
], -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"font-size":"14px","line-height":"32px","padding-top":"4px"} }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: "",
    style: {"width":"16px"}
  })
], -1))

import { ref, reactive, watch, computed } from 'vue'
import { t } from '@/plugins/i18n'
import countryCodes from '@/views/signup/components/countryCodes'
import setName from '@/util/useArea'
import useForm from '@/util/useForm'
import useRules, { useMust, useRule } from '@/util/useRules'
import { useStore } from 'vuex'
import CommonDialog from '@/components/common/CommonDialog.vue'
import SortSelect from '@/components/common/SortSelect.vue'
import { getCountryListApi } from '@/apis/user'
import { getTotalCountryList, getAreaList, getAddressCodeName } from '@/util/useCountry'
import { Jp2En } from '@/apis/address'
import { prop } from 'vue-class-component'
import { useSite2Code, isJA, isKO, isEN, useSite, isJK, getCustomerNationCode, useSite2Station, isMultiStore } from '@/store'
import { countries } from '@/common/const'
import { openKakooAddr } from '@/plugins/addr'
import { debounce } from 'lodash'

/**
 * name 对应关系
 * { label: '收货地址', name: 'take' },
  { label: '清关地址', name: 'clear' }
 */

/**
  * 日本站收货地址日本地区需要填写日语 其他英语
  * 韩国站 都用英语
  */
// 是否为日本站点
// const isJapanStation = useSite2Station() === 'JapanStation'
// defaultCountryCode 默认出口国

export default /*#__PURE__*/_defineComponent({
  props: ['data', 'name', 'update', 'visible', 'defaultCountryCode'],
  emits: ['update:data', 'update:visible'],
  setup(__props, { emit }) {

const props = __props



const store = useStore()
// 是否展示出口国家
const isShowExportCountry = computed(() => {
  // 只有开通了韩国仓且为清关地址才展示
  return props.name === 'clear' && isMultiStore()
})

const model: any = ref({
  countryCode: '',
  clearanceType: 1,
  email: store.getters.user.customerEmail ?? '',
  area: '',
  city: '',
  defaultAddress: false,
  ...props.data,
  //   默认中国 之前清关地址有
  exportCountry: isShowExportCountry.value ? props.data.exportCountry ?? props.defaultCountryCode ?? 'CN' : undefined
})

const countryList: any = ref([])
const prov1inces: any = ref([])
const cities: any = ref([])

const rules = computed(() => {
  clearFomValidate()
  /** receiveName receiveNameEn
    清关地址
    日本站
    姓名。 企业非必填 个人必填
    英文姓名 企业非必填 个人必填
    韩国站
    姓名 企业必填 个人必填 且韩文
    英文姓名 企业必填 个人必填
    英国站
    姓名 企业非必填 个人必填
    英文姓名 企业非必填 个人必填

    收货地址
    日本站
    姓名 国家选择日本才有该字段，必填  提交会从receiveNameEn赋值过去
    英文姓名 必填
    韩国站
    姓名 必填
    英文姓名 必填
    英国站
    姓名  无该字段但是提交会从receiveNameEn赋值过去
    英文姓名 必填
   */
  // 0个人1企业 model.value.clearanceType
  let rule: any = {
    country: { message: t('国家不能为空'), required: true },
    clearanceType: useMust(t('必填')),
    /**
     * 韩国站 必填
     */
    // receiveName: isKO() ? useRules({ key: 'koName' }) : isJA() ? undefined : undefined,
    // (props.name === 'clear' && model.value.clearanceType === 1) ? undefined : useRules({ message: t('收件人姓名不能为空'), key: 'noblank' }),
    phone: useRules({ message: t('联系电话不能为空'), key: 'phone' }),
    email: props.name === 'clear' ? useMust(t('邮箱不能为空')) : undefined,
    area: useMust(t('都道府县不能为空'), 'change'),
    // city: useMust(t('市不能为空'), 'change'),
    // city: countryCode.value === 'US' ? useMust(t('市不能为空'), 'change') : undefined,
    city: useMust(t('市不能为空'), 'change'),
    address: useRules({ message: t('详细地址不能为空'), key: 'address' }),
    postalCode: useRules({ message: t('邮编不能为空'), key: model.value.country === '2279' && isJA() ? 'postal' : 'postalCode' }),
    companyCode: props.name === 'clear' ? useMust(t('会社编号不能为空'), 'change') : useRule('plain'),
    companyName: props.name === 'clear' ? useMust(t('公司名不能为空'), 'change') : useRule('noblank'),
    // 非韩国站的清关地址个人校验必填 韩国必填且韩文
    receiveName: isKO() ? useRules({ key: 'koName', message: t('收件人姓名不能为空') }) : ((props.name === 'clear' && model.value.clearanceType === 1) ? undefined : useRules({ message: t('收件人姓名不能为空'), key: 'noblank' })),
    // 非韩国站清关地址企业非必填其他都必填
    receiveNameEn: (props.name === 'clear' && model.value.clearanceType === 1 && !isKO()) ? undefined : useRules({ message: t('收件人姓名不能为空'), key: 'plainEn' }),
    areaEn: useRules({ message: t('都道府县不能为空'), key: 'plainEn' }),
    cityEn: useRules({ message: t('市不能为空'), key: 'plainEn' }),
    addressEn: useRules({
      message: t('详细地址不能为空'),
      key: model.value.country === '2115' ? 'address40' : 'address'
    }),
    companyNameEn: props.name === 'clear' ? useMust(t('公司名不能为空'), 'change') : useRule('plain'),
    clearanceCode: useRules({ message: t('通关码不能为空'), key: 'clearanceCode' })
  }
  if (model.value.country !== '2279' && isJA()) {
    rule = {
      ...rule,
      city: useMust(t('市不能为空'), 'change'),
      cityEn: useRules({ message: t('市不能为空'), key: 'plainEn' })
    }
  }
  return rule
})

const cancel = () => {
  emit('update:visible', false)
}
const [formRef, commit] = useForm(async () => {
  const addressInfo = await getAddressCodeName({
    ...model.value,
    countryCode: activeNation.code
  })
  props.update({
    ...model.value,
    // 只有清关地址才需要
    exportCountry: isShowExportCountry.value ? model.value.exportCountry : undefined,
    countryCode: model.value.countryCode,
    provinceName: addressInfo?.areaItem?.[getName(addressInfo?.countryItem.code)] ?? prov1inces.value.find((v: any) => v.intAreaId === model.value.area)?.[getName(model.value.nationCode)],
    cityName: addressInfo?.cityItem?.[getName(addressInfo?.countryItem.code)] ?? cities.value.find((v: any) => v.intAreaId === model.value.city)?.[getName(model.value.nationCode)],
    countryName: addressInfo?.countryItem?.[getName(addressInfo?.countryItem.code)] ?? countryList.value.find((v: any) => v.intAreaId === model.value.country)?.[getName(model.value.nationCode)],
    nationCode: addressInfo?.countryItem.code,
    nationId: addressInfo?.countryItem.intAreaId,
    // 特殊处理
    receiveName: ((model.value.country === '2279' && isJA()) || isKO()) ? model.value.receiveName : model.value.receiveNameEn,
    address: isJK() ? model.value.address : model.value.addressEn,
    // 英国站只需要英文公司名称
    companyName: isEN() ? model.value.companyNameEn : model.value.companyName
  }).then((res: boolean) => {
    if (res) {
      emit('update:visible', false)
    }
  })
})
// 获取所有物流对应的国家信息
const init = async () => {
  model.value = {
    countryCode: '',
    clearanceType: 1,
    email: store.getters.user.customerEmail ?? '',
    area: '',
    city: '',
    defaultAddress: false,
    exportCountry: isShowExportCountry.value ? props.data.exportCountry ?? props.defaultCountryCode ?? 'CN' : undefined
  }
  prov1inces.value = []
  cities.value = []

  const countryResult = await getCountryListApi({})
  const allCountry = await getTotalCountryList()
  const code = countryResult.data.map((i: any) => i.countryCode)
  if (props.name === 'clear') {
    // 清关地址日本韩国默认去对应国家，英国站取7个国家
    const country:any = countries.filter((item) => {
      return item.navigatorLang.join(',').indexOf(useSite()) > -1
    }).map((item) => {
      return item.key
    })
    if (isEN()) {
      country.push('US')
      country.push('CH')
      country.push('ID')
    }
    console.log('country', country)
    countryList.value = allCountry.filter((i: any) => country.indexOf(i.code) > -1)
  } else {
    countryList.value = allCountry.filter((i: any) => code.indexOf(i.code) > -1)
  }
}
// 选中的国家信息
let activeNation: any = {}
const countryCode = ref('')
const changeCountry = (countryItem: any) => {
  countryCode.value = countryItem.code
  activeNation = countryItem
  model.value.area = ''
  model.value.areaEn = ''
  model.value.city = ''
  model.value.cityEn = ''
  model.value.countryCode = '+' + countryItem.areaNum
  getAreaList(countryItem).then((res: any) => {
    prov1inces.value = res
    cities.value = []
    setTimeout(() => {
      formRef.value.clearValidate(['area', 'city'])
    })
  })
}
const changeArea = async (areaItem: any) => {
  //
  model.value.areaEn = (areaItem.nameEn ? areaItem.nameEn : (await Jp2En({ text: areaItem.name })).data) || ''
  cities.value = areaItem.children || []
  // model.value.city = cities.value.length === 0 ? '-' : ''
  // model.value.cityEn = cities.value.length === 0 ? '-' : ''
}
watch(() => model.value.area, async (areaItem) => {
  model.value.city = cities.value.length === 0 ? '-' : ''
  model.value.cityEn = cities.value.length === 0 ? '-' : ''
})

const changeCity = async (areaItem: any) => {
  model.value.cityEn = areaItem.nameEn ? areaItem.nameEn : (await Jp2En({ text: areaItem.name })).data
}
const changeAddress = debounce(async () => {
  model.value.addressEn = model.value.address ? (await Jp2En({ text: model.value.address })).data : ''
}, 1000)

watch(() => model.value.address, changeAddress)
// const changeCompanyName = async () => {
//   model.value.companyNameEn = model.value.companyName ? (await Jp2En({ text: model.value.companyName })).data : ''
// }

watch(() => props.visible, async (newValue: any) => {
  if (newValue) {
    await init()
    if (props.data.isCreate) {
      console.log('创建')
      // 默认当前国家
      const jpCountry = countryList.value.find((i: any) => i.code === getCustomerNationCode())
      if (jpCountry) {
        model.value.countryCode = '+81'
        model.value.country = jpCountry ? jpCountry.intAreaId : ''
        changeCountry(jpCountry)
      }
    } else {
      console.log('修改')
      model.value = {
        ...props.data,
        exportCountry: isShowExportCountry.value ? props.data.exportCountry ?? 'CN' : undefined
      }
      const addressInfo = await getAddressCodeName({
        // 如果没有nationCode则是老数据，默认日本
        countryCode: props.data.nationCode || useSite2Code(),
        city: props.data.city,
        area: props.data.area
      })
      console.log('iii', props.data.city, addressInfo)
      prov1inces.value = addressInfo.areaList
      cities.value = addressInfo.cityList || []
      if (cities.value.length === 0) {
        model.value.cityEn = '-'
        model.value.city = '-'
      } else {
        model.value.city = addressInfo?.city
        model.value.cityEn = props.data?.cityEn
      }

      model.value.country = addressInfo?.countryItem.intAreaId
      model.value.countryCode = '+' + addressInfo?.countryItem.areaNum
      // model.value.country = addressInfo
    }
  }
}, {
  immediate: true
})

const clearFomValidate = () => {
  setTimeout(() => {
    formRef.value && formRef.value.clearValidate()
  })
}

// JP KR en?
const getName = (code: string) => {
  if (code === 'JP' && isJA()) {
    return 'nameJa'
  }
  if (code === 'KR' && isKO()) {
    return 'nameKr'
  }
  return 'nameEn'
}

return (_ctx: any,_cache: any) => {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createBlock(CommonDialog, {
    visible: __props.visible,
    "onUpdate:visible": _cache[26] || (_cache[26] = ($event: any) => (_isRef(visible) ? (visible).value = $event : null)),
    title: __props.data.isCreate ? _unref(t)('添加新地址') : _unref(t)('编辑地址'),
    width: 650,
    footer: true,
    className: "addr-form-dialog",
    okText: _unref(t)(__props.data.isCreate ? '添加地址' : _unref(t)('修改地址')),
    cancelText: _unref(t)('取消'),
    onOk: _unref(commit),
    onCancel: cancel
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _renderSlot(_ctx.$slots, "default"),
        _createVNode(_component_el_form, {
          class: "receive-form rel",
          ref: (_value, _refs) => {
            _refs['formRef'] = _value
            _isRef(formRef) && (formRef.value = _value)
          },
          model: model.value,
          rules: _unref(rules),
          "label-width": 138,
          inline: true
        }, {
          default: _withCtx(() => [
            (_unref(isShowExportCountry))
              ? (_openBlock(), _createBlock(_component_el_form_item, {
                  key: 0,
                  prop: "exportCountry",
                  label: _unref(t)('出口国家')
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_select, {
                      modelValue: model.value.exportCountry,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((model.value.exportCountry) = $event)),
                      style: {"width":"400px"},
                      disabled: !_unref(isMultiStore)() || __props.defaultCountryCode
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_option, {
                          label: _unref(t)('中国'),
                          value: "CN"
                        }, null, 8, ["label"]),
                        (_unref(isMultiStore)())
                          ? (_openBlock(), _createBlock(_component_el_option, {
                              key: 0,
                              label: _unref(t)('韩国'),
                              value: "KR"
                            }, null, 8, ["label"]))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    }, 8, ["modelValue", "disabled"])
                  ]),
                  _: 1
                }, 8, ["label"]))
              : _createCommentVNode("", true),
            _createVNode(_component_el_form_item, {
              prop: "country",
              label: _unref(t)('国/地区')
            }, {
              default: _withCtx(() => [
                (_unref(isEN)() || __props.name === 'take')
                  ? (_openBlock(), _createBlock(SortSelect, {
                      key: 0,
                      value: model.value.country,
                      "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((model.value.country) = $event)),
                      onChange: changeCountry,
                      list: countryList.value,
                      type: "country",
                      rowKey: "intAreaId",
                      width: 400,
                      "dont-select": _unref(isKO)()
                    }, null, 8, ["value", "list", "dont-select"]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_2, [
                      (_unref(isJA)())
                        ? (_openBlock(), _createBlock(_component_el_input, {
                            key: 0,
                            type: "text",
                            placeholder: "Japan 日本",
                            disabled: true,
                            style: {"width":"400px"}
                          }))
                        : _createCommentVNode("", true),
                      (_unref(isKO)())
                        ? (_openBlock(), _createBlock(_component_el_input, {
                            key: 1,
                            type: "text",
                            placeholder: "Republic of Korea 대한민국",
                            disabled: true,
                            style: {"width":"400px"}
                          }))
                        : _createCommentVNode("", true)
                    ]))
              ]),
              _: 1
            }, 8, ["label"]),
            (__props.name === 'clear')
              ? (_openBlock(), _createBlock(_component_el_form_item, {
                  key: 1,
                  prop: "clearanceType",
                  label: _unref(t)('通关名义')
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_select, {
                      modelValue: model.value.clearanceType,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((model.value.clearanceType) = $event)),
                      style: {"width":"400px"}
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_option, {
                          label: _unref(t)('个人'),
                          value: 0
                        }, null, 8, ["label"]),
                        _createVNode(_component_el_option, {
                          label: _unref(t)('企业'),
                          value: 1
                        }, null, 8, ["label"])
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _: 1
                }, 8, ["label"]))
              : _createCommentVNode("", true),
            (__props.name === 'clear' && _unref(isKO)())
              ? (_openBlock(), _createBlock(_component_el_form_item, {
                  key: 2,
                  prop: "clearanceCode",
                  label: _unref(t)('通关码')
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      type: "text",
                      class: "receive-name",
                      modelValue: model.value.clearanceCode,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((model.value.clearanceCode) = $event)),
                      maxlength: 30,
                      style: {"width":"400px"}
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }, 8, ["label"]))
              : _createCommentVNode("", true),
            (model.value.country === '2279' && _unref(isJA)() || _unref(isKO)())
              ? (_openBlock(), _createBlock(_component_el_row, { key: 3 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_col, { span: 13 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_form_item, {
                          prop: "receiveName",
                          label: _unref(t)('姓名'),
                          required: _unref(isKO)()
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_input, {
                              type: "text",
                              class: "receive-name",
                              modelValue: model.value.receiveName,
                              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((model.value.receiveName) = $event)),
                              maxlength: 20,
                              placeholder: _unref(t)(_unref(isJA)() ? '日文名' : '韩文名'),
                              style: {"width":"185px"}
                            }, null, 8, ["modelValue", "placeholder"])
                          ]),
                          _: 1
                        }, 8, ["label", "required"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_col, { span: 1 }, {
                      default: _withCtx(() => [
                        _hoisted_3
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_col, { span: 9 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_form_item, { prop: "receiveNameEn" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_input, {
                              type: "text",
                              class: "receive-name",
                              modelValue: model.value.receiveNameEn,
                              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((model.value.receiveNameEn) = $event)),
                              maxlength: 20,
                              placeholder: _unref(t)(_unref(isKO)() ? '请输入英文' : '英文名'),
                              style: {"width":"182px"}
                            }, null, 8, ["modelValue", "placeholder"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }))
              : (_openBlock(), _createBlock(_component_el_row, { key: 4 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_col, { span: 24 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_form_item, {
                          prop: "receiveNameEn",
                          label: _unref(t)('姓名')
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_input, {
                              type: "text",
                              class: "receive-name",
                              modelValue: model.value.receiveNameEn,
                              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((model.value.receiveNameEn) = $event)),
                              maxlength: 20,
                              placeholder: _unref(t)('英文名'),
                              style: {"width":"400px"}
                            }, null, 8, ["modelValue", "placeholder"])
                          ]),
                          _: 1
                        }, 8, ["label"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })),
            (__props.name === 'clear' && model.value.clearanceType === 1)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 5 }, [
                  _createVNode(_component_el_row, null, {
                    default: _withCtx(() => [
                      (_unref(isJK)())
                        ? (_openBlock(), _createBlock(_component_el_col, {
                            key: 0,
                            span: 13
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_form_item, {
                                prop: "companyName",
                                label: _unref(t)('公司名')
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_input, {
                                    type: "text",
                                    class: "receive-name",
                                    modelValue: model.value.companyName,
                                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((model.value.companyName) = $event)),
                                    maxlength: 30,
                                    placeholder: _unref(t)(_unref(isJA)() ? '日文名' : '韩文名'),
                                    style: {"width":"185px"}
                                  }, null, 8, ["modelValue", "placeholder"])
                                ]),
                                _: 1
                              }, 8, ["label"])
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      (_unref(isJK)())
                        ? (_openBlock(), _createBlock(_component_el_col, {
                            key: 1,
                            span: 1
                          }, {
                            default: _withCtx(() => [
                              _hoisted_4
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      _createVNode(_component_el_col, { span: 9 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_form_item, {
                            prop: "companyNameEn",
                            label: _unref(isEN)() ? _unref(t)('公司名') : ''
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_input, {
                                type: "text",
                                class: "receive-name",
                                modelValue: model.value.companyNameEn,
                                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((model.value.companyNameEn) = $event)),
                                maxlength: 30,
                                style: _normalizeStyle({ width: _unref(isEN)() ? '400px' : '182px' }),
                                placeholder: _unref(t)('公司英文名')
                              }, null, 8, ["modelValue", "style", "placeholder"])
                            ]),
                            _: 1
                          }, 8, ["label"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_form_item, {
                    prop: "companyCode",
                    label: _unref(t)('会社编号')
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        type: "text",
                        class: "receive-name",
                        modelValue: model.value.companyCode,
                        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((model.value.companyCode) = $event)),
                        maxlength: 30,
                        style: {"width":"400px"}
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }, 8, ["label"])
                ], 64))
              : _createCommentVNode("", true),
            _createVNode(_component_el_form_item, {
              prop: "phone",
              label: _unref(t)('联系电话')
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  type: "text",
                  class: "receive-tel",
                  modelValue: model.value.phone,
                  "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((model.value.phone) = $event)),
                  maxlength: 20,
                  placeholder: _unref(t)('请输入手机号'),
                  style: {"width":"400px"}
                }, {
                  prepend: _withCtx(() => [
                    _createTextVNode(_toDisplayString(model.value.countryCode || '-'), 1)
                  ]),
                  _: 1
                }, 8, ["modelValue", "placeholder"])
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_form_item, {
              prop: "email",
              label: _unref(t)('邮箱')
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  type: "text",
                  class: "receive-email",
                  modelValue: model.value.email,
                  "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((model.value.email) = $event)),
                  maxlength: 40,
                  placeholder: _unref(t)('请输入邮箱'),
                  style: {"width":"400px"}
                }, null, 8, ["modelValue", "placeholder"])
              ]),
              _: 1
            }, 8, ["label"]),
            (_unref(isKO)())
              ? (_openBlock(), _createBlock(_component_el_form_item, {
                  key: 6,
                  prop: "postalCode",
                  label: _unref(t)('邮编')
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      type: "text",
                      class: "postal-code",
                      modelValue: model.value.postalCode,
                      "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((model.value.postalCode) = $event)),
                      maxlength: 20,
                      placeholder: _unref(t)('请输入邮编'),
                      style: {"width":"300px","margin-right":"10px"},
                      disabled: "",
                      readonly: ""
                    }, null, 8, ["modelValue", "placeholder"]),
                    _createVNode(_component_el_button, {
                      type: "primary",
                      style: {"width":"90px"},
                      onClick: _cache[13] || (_cache[13] = ($event: any) => (_unref(openKakooAddr)(model.value, prov1inces.value, ['area'])))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_unref(t)('搜索地址')), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["label"]))
              : (_openBlock(), _createBlock(_component_el_form_item, {
                  key: 7,
                  prop: "postalCode",
                  label: _unref(t)('邮编')
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      type: "text",
                      class: "postal-code",
                      modelValue: model.value.postalCode,
                      "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((model.value.postalCode) = $event)),
                      maxlength: 20,
                      placeholder: _unref(t)('请输入邮编'),
                      style: {"width":"400px"}
                    }, null, 8, ["modelValue", "placeholder"])
                  ]),
                  _: 1
                }, 8, ["label"])),
            (model.value.country === '2279' && _unref(isJA)())
              ? (_openBlock(), _createBlock(_component_el_row, { key: 8 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_col, { span: 13 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_form_item, {
                          prop: "area",
                          label: _unref(t)('都道府县')
                        }, {
                          default: _withCtx(() => [
                            _createVNode(SortSelect, {
                              value: model.value.area,
                              "onUpdate:value": _cache[15] || (_cache[15] = ($event: any) => ((model.value.area) = $event)),
                              onChange: changeArea,
                              list: prov1inces.value,
                              type: "area",
                              rowKey: "intAreaId",
                              width: 185,
                              country: model.value.country,
                              placeholder: _unref(t)('都道府县日文')
                            }, null, 8, ["value", "list", "country", "placeholder"])
                          ]),
                          _: 1
                        }, 8, ["label"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_col, { span: 1 }, {
                      default: _withCtx(() => [
                        _hoisted_5
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_col, { span: 9 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_form_item, { prop: "areaEn" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_input, {
                              class: "short-input",
                              modelValue: model.value.areaEn,
                              "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((model.value.areaEn) = $event)),
                              style: {"width":"182px"},
                              placeholder: _unref(t)('都道府县英文'),
                              disabled: prov1inces.value.length === 0
                            }, null, 8, ["modelValue", "placeholder", "disabled"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }))
              : (_openBlock(), _createBlock(_component_el_row, { key: 9 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_col, { span: 24 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_form_item, {
                          prop: "area",
                          label: _unref(t)('都道府县')
                        }, {
                          default: _withCtx(() => [
                            _createVNode(SortSelect, {
                              value: model.value.area,
                              "onUpdate:value": _cache[17] || (_cache[17] = ($event: any) => ((model.value.area) = $event)),
                              onChange: changeArea,
                              list: prov1inces.value,
                              type: "area",
                              rowKey: "intAreaId",
                              width: 400,
                              country: model.value.country,
                              placeholder: _unref(t)('都道府县英文'),
                              "dont-select": _unref(isKO)()
                            }, null, 8, ["value", "list", "country", "placeholder", "dont-select"])
                          ]),
                          _: 1
                        }, 8, ["label"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })),
            (model.value.country === '2279' && _unref(isJA)())
              ? (_openBlock(), _createBlock(_component_el_row, { key: 10 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_col, { span: 13 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_form_item, {
                          prop: "city",
                          label: _unref(t)('市区町村')
                        }, {
                          default: _withCtx(() => [
                            _createVNode(SortSelect, {
                              value: model.value.city,
                              "onUpdate:value": _cache[18] || (_cache[18] = ($event: any) => ((model.value.city) = $event)),
                              list: cities.value,
                              type: "city",
                              rowKey: "intAreaId",
                              width: 185,
                              country: model.value.country,
                              onChange: changeCity,
                              placeholder: _unref(t)('市区町村日文')
                            }, null, 8, ["value", "list", "country", "placeholder"])
                          ]),
                          _: 1
                        }, 8, ["label"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_col, { span: 1 }, {
                      default: _withCtx(() => [
                        _hoisted_6
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_col, { span: 9 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_form_item, { prop: "cityEn" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_input, {
                              class: "short-input",
                              modelValue: model.value.cityEn,
                              "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((model.value.cityEn) = $event)),
                              style: {"width":"182px"},
                              placeholder: _unref(t)('市区町村英文'),
                              disabled: cities.value.length === 0
                            }, null, 8, ["modelValue", "placeholder", "disabled"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }))
              : (!_unref(isKO)())
                ? (_openBlock(), _createBlock(_component_el_row, { key: 11 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_col, { span: 24 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_form_item, {
                            prop: "city",
                            label: _unref(t)('市')
                          }, {
                            default: _withCtx(() => [
                              _createVNode(SortSelect, {
                                value: model.value.city,
                                "onUpdate:value": _cache[20] || (_cache[20] = ($event: any) => ((model.value.city) = $event)),
                                list: cities.value,
                                type: "city",
                                rowKey: "intAreaId",
                                width: 400,
                                country: model.value.country,
                                onChange: changeCity,
                                placeholder: _unref(t)('市区町村英文')
                              }, null, 8, ["value", "list", "country", "placeholder"])
                            ]),
                            _: 1
                          }, 8, ["label"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
            _createVNode(_component_el_form_item, {
              style: {"width":"80%"},
              prop: (model.value.country === '2279' && _unref(isJA)() || _unref(isKO)()) ? 'address' : 'addressEn',
              label: _unref(t)('详细地址')
            }, {
              default: _withCtx(() => [
                (model.value.country === '2279' && _unref(isJA)())
                  ? (_openBlock(), _createBlock(_component_el_input, {
                      key: 0,
                      type: "textarea",
                      autosize: { minRows: 2, maxRows: 2 },
                      class: "receive-address",
                      modelValue: model.value.address,
                      "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((model.value.address) = $event)),
                      maxlength: 100,
                      placeholder: _unref(t)('请输入日文详细住所'),
                      style: {"width":"400px"},
                      onBlur: _unref(changeAddress)
                    }, null, 8, ["modelValue", "placeholder", "onBlur"]))
                  : _createCommentVNode("", true),
                (_unref(isKO)())
                  ? (_openBlock(), _createBlock(_component_el_input, {
                      key: 1,
                      type: "textarea",
                      autosize: { minRows: 2, maxRows: 2 },
                      class: "receive-address",
                      modelValue: model.value.address,
                      "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((model.value.address) = $event)),
                      maxlength: 100,
                      placeholder: _unref(t)('请输入韩文详细住所'),
                      style: {"width":"400px","margin-bottom":"10px"},
                      onBlur: _unref(changeAddress)
                    }, null, 8, ["modelValue", "placeholder", "onBlur"]))
                  : _createCommentVNode("", true),
                _createVNode(_component_el_input, {
                  type: "textarea",
                  autosize: { minRows: 2, maxRows: 2 },
                  class: "receive-address mt_10",
                  modelValue: model.value.addressEn,
                  "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((model.value.addressEn) = $event)),
                  maxlength: 200,
                  placeholder: _unref(t)('请输入英文详细住所')
                }, null, 8, ["modelValue", "placeholder"])
              ]),
              _: 1
            }, 8, ["prop", "label"]),
            (_unref(isEN)())
              ? (_openBlock(), _createBlock(_component_el_form_item, {
                  key: 12,
                  style: {"width":"80%","padding-left":"138px"},
                  prop: "addressEn"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      type: "textarea",
                      autosize: { minRows: 2, maxRows: 2 },
                      class: "receive-address",
                      modelValue: model.value.addressEn,
                      "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((model.value.addressEn) = $event)),
                      maxlength: 200,
                      placeholder: _unref(t)('请输入英文详细住所')
                    }, null, 8, ["modelValue", "placeholder"])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            _createVNode(_component_el_checkbox, {
              class: "abs set-default",
              modelValue: model.value.defaultAddress,
              "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((model.value.defaultAddress) = $event))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(t)('设为默认')), 1)
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _: 1
        }, 8, ["model", "rules"])
      ])
    ]),
    _: 3
  }, 8, ["visible", "title", "okText", "cancelText", "onOk"]))
}
}

})